<template>
  <div class="main-view">
    <el-card shadow="never">
      <div slot="header">联系客服</div>
      <el-form ref="formRef1" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="联系电话" prop="phone">
          <el-input
            style="width: 360px"
            clearable
            size="small"
            placeholder="请输入"
            v-model="form.phone"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="客服微信" prop="customer_wechat">
          <el-input
            style="width: 360px"
            clearable
            size="small"
            placeholder="请输入"
            v-model="form.customer_wechat"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">提高曝光</div>
      <el-form ref="formRef2" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="微信号1" prop="wechat1">
          <el-input
            style="width: 360px"
            clearable
            size="small"
            placeholder="请输入"
            v-model="form.wechat1"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="微信号2" prop="wechat2">
          <el-input
            style="width: 360px"
            clearable
            size="small"
            placeholder="请输入"
            v-model="form.wechat2"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">社群二维码</div>
      <el-form ref="formRef3" :model="form" label-width="auto" :rules="rules">
        <el-form-item prop="code" label="二维码">
          <el-upload
            class="avatar-uploader-login"
            action=""
            :headers="{ token: token }"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :http-request="httpRequest"
          >
            <div v-if="form.code" class="img-wrap">
              <img :src="form.code" class="avatar" />
              <!-- 删除按钮 -->
              <div class="delete-mask" @click.stop="delImg">
                <i class="el-icon-delete del-icon"></i>
              </div>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <!-- <div class="el-upload__tip" slot="tip">建议尺寸：100*100像素</div> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="footerWrap">
        <el-button type="primary" :loading="baseBtnLoading" @click="saveBase"
          >保 存</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      token: "",
      baseBtnLoading: false,
      form: {
        phone: "",
        customer_wechat: "",
        wechat1: "",
        wechat2: "",
        code: "",
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
        ],
        customer_wechat: [
          {
            required: true,
            message: "请输入客服微信",
            trigger: "blur",
          },
        ],
        wechat1: [
          {
            required: true,
            message: "请输入电话格式的微信号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    httpRequest(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post("/common/qiniu/uploadFile", { formData, type: "upload" })
        .then((res) => {
          this.form.code = res.data.all_path_url;
          this.$refs.formRef3.clearValidate();
        });
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt5M;
    },
    delImg() {
      this.form.code = "";
    },
    init() {
      this.$http
        .get("/admin/flex_config/customer", { params: {} })
        .then((res) => {
          if (res.code == 1) {
            this.form = res.data || {};
          }
        });
    },
    async saveBase() {
      // 验证表单
      let promiseList = [
        this.$refs.formRef3.validate(),
        this.$refs.formRef2.validate(),
        this.$refs.formRef1.validate(),
      ];
      try {
        const results = await Promise.all(promiseList);
        const allValid = results.every((result) => result === true);
        if (allValid) {
          this.baseBtnLoading = true;
          let params = {
            ...this.form,
          };
          this.$http
            .post("/admin/flex_config/setCustomer", params)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("保存成功");
                this.init();
              }
            })
            .finally(() => {
              this.baseBtnLoading = false;
            });
          // 在这里可以执行提交逻辑
        } else {
          console.log("部分表单验证失败");
        }
      } catch (error) {
        console.error("表单验证过程中发生错误:", error);
      }
    },
  },
};
</script>
<style scoped>
.avatar-uploader-login .el-icon-plus {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.avatar-uploader-login .avatar-uploader-icon {
  line-height: 100px !important;
}
.avatar-uploader-login .avatar {
  width: 100px;
  height: 100px;
}
.avatar-uploader-image .el-icon-plus {
  width: 234px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.avatar-uploader-image .avatar {
  width: 234px;
  height: 100px;
}
.avatar-uploader-image .avatar-uploader-icon {
  line-height: 100px !important;
}
.el-upload__tip {
  color: #f56c6c;
  margin-top: 0;
}
</style>
<style scoped>
.avatar-uploader-login .avatar {
  width: 100px;
  height: 100px;
  /* 去掉圆角！！ */
  /* border-radius: 50%; */
  object-fit: cover;
  display: block;
}
.img-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  /* 删掉圆形裁剪 */
  /* border-radius: 50%;
  overflow: hidden; */
}
/* 遮罩层 默认隐藏 */
.delete-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 方形遮罩，直角 */
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  cursor: pointer;
  transition: opacity 0.25s ease;
}
/* hover显示 */
.img-wrap:hover .delete-mask {
  opacity: 1;
}
.del-icon {
  font-size: 24px;
  color: #ffffff;
}
.footerWrap {
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
  z-index: 99;
  background: #fff;
}
</style>